import { Directive, Output, HostListener, EventEmitter } from '@angular/core';


/**------------------------------------------------------
 * Drag and drop Single
 * --------------------
 * The user can drag and drop file over the container and
 * can utilize it for functionalities like handling upload,
 * Example:
 * --------
 * 	<div ngDragDropSingle (fileDropped)> ... </div>
 */
@Directive({
    selector: '[ngDragDropSingle]',
    standalone: false
})
export class NgDragDropSingleDirective {

	@Output() readonly fileDropped		: EventEmitter<File> = new EventEmitter<File>();
	@Output() readonly draggedOverEvent	: EventEmitter<void> = new EventEmitter<void>();

	@HostListener('dragover', ['$event'])
	public onDragOver(event: Event): void {
		this.draggedOverEvent.emit();
		this.stopEventRipple(event);
	}

	@HostListener('dragleave', ['$event'])
	public onDragLeave(event: Event): void {
		this.stopEventRipple(event);
	}

	@HostListener('drop', ['$event'])
	public onDrop(event: DragEvent): void {

		//0 - stop the event
		this.stopEventRipple(event);

		//1 - check if file is dropped
		if (!event.dataTransfer!.files.length) return;

		//2 - emit the file
		this.fileDropped.emit(event.dataTransfer!.files[0]); // only one file is allowed
	}

	/**------------------------------------------------------
	 * Helper Function
	 */
	private stopEventRipple(event: Event) {
		event.preventDefault();
		event.stopPropagation();
	}
}
